import { Team, TeamDialogService, TeamMemberDialogService, TeamMemberService, TeamService } from '@teammood/team';
import { UserService } from 'app/frontend/lib/shared/util/user';
import { filter, takeUntil, tap } from 'rxjs';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoggerService } from '@teammood/shared/util/logger';
import { Member } from '../../team/team-member/team-members-list/team-members-list.component';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'team-members',
    templateUrl: './team-members.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TeamMembersComponent implements OnInit {

    private userId: string;
    teammembers: Member[];
    team: Team;
    teamNameError: boolean;
    step: { id: string, index: number } = { id: 'team_members', index: 3 };

    constructor(
        private log: LoggerService,
        private userService: UserService,
        private teamService: TeamService,
        private teamMemberService: TeamMemberService,
        private teamMemberDialogService: TeamMemberDialogService,
        private teamDialogService: TeamDialogService,
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    async ngOnInit() {
        this.userId = this.route.snapshot.params['userId'];

        this.userService.get().then((user) => {
            this.teamService.get(user.teamId).then((team) => {
                this.team = team;
                this.teamMemberService.query(this.team.id).then(teamMembers => {
                    this.teammembers = teamMembers;
                })
            });
        });
    }

    async memberChanged () {
        this.teammembers = await this.teamMemberService.query(this.team.id);
    }

    async createTeamMember () {
        const dialogRef = await this.teamMemberDialogService.create(this.team);

        dialogRef.beforeClosed().pipe(
            filter((shouldReload) => !!shouldReload),
            tap(() => this.memberChanged()),
            takeUntil(dialogRef.afterClosed())
        ).subscribe();
    }

    openBatchImportDialog = async () => {
        if(this.team) {
            await this.teamDialogService.importTeamMembers(this.team);
        }
    }

    async next () {
        await this.router.navigate(['/onboarding', this.userId, 'ready']);
    }

    save_team_name(teamName: string) {
        if (teamName && teamName.length >= 2) {
            this.team = {
                ...this.team,
                name: teamName
            }
            this.teamService.update(this.team)
                .then(() => { this.log.info('Team name updated.') })
                .catch(error => this.log.error('Error on team name update:', error))
                this.teamNameError = false;
        }else{
            this.teamNameError = true;
        }
    }
}

